import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { RoutesSlugs } from "@app/routes-slugs";
import { GetUserProfileUseCase } from "@app/core/user/domain/use-cases/get-user-profile.use-case";
import { catchError, map, of } from "rxjs";

export const adminOnlyGuard: CanActivateFn = () => {
  const router = inject(Router);
  const getUserProfileUseCase = inject(GetUserProfileUseCase);

  return getUserProfileUseCase.execute().pipe(
    map((user) => {
      if (user.isAdmin === true) {
        return true;
      }
      return router.createUrlTree(["/", RoutesSlugs.HOME]);
    }),
    catchError(() => of(router.createUrlTree(["/", RoutesSlugs.HOME])))
  );
};
